import React, { memo } from 'react';
import styled, { css } from 'styled-components';

type BannerVariant = 'successPill' | 'error' | 'info';

type ScanResultBannerProps = {
	variant: BannerVariant;
	text: string;
};

// 스캔 결과 상단 배너 (체크인 가능 pill / 오류 배너 / 본인확인 안내)
const ScanResultBanner = memo<ScanResultBannerProps>(({ variant, text }) => {
	const icon = variant === 'error' ? '✕' : variant === 'info' ? '!' : '✓';

	return (
		<Wrapper $variant={variant}>
			<Icon>{icon}</Icon>
			{text}
		</Wrapper>
	);
});

ScanResultBanner.displayName = 'ScanResultBanner';

export default ScanResultBanner;

const Wrapper = styled.div<{ $variant: BannerVariant }>`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	font-family: PretendardSemiBold, AppleSDGothicNeoSemiBold, sans-serif;
	padding: 12px 16px;
	border-radius: 6px;

	${({ $variant, theme }) =>
		$variant === 'successPill' &&
		css`
			color: #2f9e5f;
			background-color: #e6f6ec;
		`};

	${({ $variant, theme }) =>
		($variant === 'error' || $variant === 'info') &&
		css`
			display: flex;
			color: ${theme.colors.activeRedOrange};
			background-color: #ffede3;
		`};
`;
const Icon = styled.span`
	font-size: 13px;
`;
